import { EsgCompiledEligibilityTestApi } from "@/api";
import i18n from "@/i18n";
import router from "@/router";
import { showSuccessSnackbar, snackBarMapError } from "@/utilities/snackbar";
import { DownloadFile } from "@/utilities/fileManager.js";

export async function getAll(params) {
  const { data } = await EsgCompiledEligibilityTestApi.getAll(params);
  return data;
}

export async function get(id, params) {
  try {
    const { data } = await EsgCompiledEligibilityTestApi.get(id, params);
    return data;
  } catch (ex) {
    snackBarMapError("esg.eligibility-test-not-found");
    if (ex.response.status === 404) {
      router.push({ name: "esg.eligibility-tests.index" });
    }
  }
}

export async function save(data) {
  const { data: savedData } = await EsgCompiledEligibilityTestApi.save(data);
  showSuccessSnackbar(200, i18n.t("esg.eligibility-test-saved-correctly"));
  return savedData;
}

export async function exportResult(id) {
  try {
    const response = await EsgCompiledEligibilityTestApi.exportResult(id);
    // fallback: compiled_eligibility_test_result_<data>.zip
    const gendate = new Date()
      .toISOString()
      .replace(/[-:]/g, "")
      .replace("T", "_")
      .replace("Z", "")
      .split(".")[0];
    const fallbackFileName = `compiled_eligibility_test_result_${gendate}.zip`;
    DownloadFile.downloadBlobWithHeaders(
      response.data.file,
      "application/octet-stream",
      response.headers,
      fallbackFileName
    );
  } catch (ex) {
    snackBarMapError(undefined, i18n.t("something-went-wrong") + ex);
    if (ex.response.status === 404) {
      router.push({ name: "esg.eligibility-tests.index" });
    }
  }
}

export async function downloadAllCompliantDocumentationFiles(
  id,
  fallbackFileName
) {
  let response;
  try {
    response =
      await EsgCompiledEligibilityTestApi.downloadAllCompliantDocumentationFiles(
        id
      );
    DownloadFile.downloadBlobWithHeaders(
      response.data,
      response.headers,
      fallbackFileName
    );
  } catch (ex) {
    snackBarMapError(undefined, i18n.t("something-went-wrong") + ex);
  }
}
